export const REGULARISATIONCONTRIBUTIONTRANSACTION = 'REGULARISATIONCONTRIBUTIONTRANSACTION';
export const REGULARISATIONSUBSCRIPTION = 'REGULARISATIONSUBSCRIPTION';
export const DEPOSITCONTRIBUTIONTRANSACTION = 'DEPOSITCONTRIBUTIONTRANSACTION';